export const PAYMENT_TYPE = {
  FIAT: 'fiat',
  CRYPTO: 'crypto',
}

export const DATE_FORMAT = 'YYYY-MM-DD'
export const MONTH_FORMAT = 'YYYY-MM'
export const START_DATE = 'startDate'
export const END_DATE = 'endDate'

export const UPLISTING_MAP_HOME_RULES: any = {
  children: {
    '0': 'Not suitable for children',
    '1': 'Suitable for children',
  },
  events: {
    '0': 'No parties or events',
    '1': 'Events allowed',
  },
  pets: {
    '0': 'No pets',
    '1': 'Pets allowed',
  },
  smoking: {
    '0': 'No smoking',
    '1': 'Smoking is allowed',
  },
  infants: {
    '0': 'Not suitable for infants',
    '1': 'Suitable for infants',
  },
}

export const FEES_AND_DISCOUNT: any = {
  cleaningFee: 'Cleaning fee',
  additionalCleaningFee: 'Additional cleaning fee',
  parkingFee: 'Parking fee',
  towelChangeFee: 'Towel change fee',
  midstayCleaningFee: 'Mid- stay cleaning fee',
  roomRequestFee: 'Room request fee',
  reservationChangeFee: 'Reservation change fee',
  lateCheckoutFee: 'Late check - out fee',
  otherFees: 'Other fees',
  creditCardFee: 'Card processing fee',
  kitchenLinenFee: 'Kitchen linen fee',
  linenPackageFee: 'Linen package fee',
  transferFee: 'Transfer fee',
  wristbandFee: 'Wristband fee',
  extraBedsFee: 'Extra beds fee',
  serviceFee: 'Service fee',
  bedLinenFee: 'Bed linen fee',
  bookingFee: 'Booking fee',
  petFee: 'Pet fee',
  skiPassFee: 'Ski pass fee',
  tourismFee: 'Tourism fee',
  childrenExtraFee: 'Extra children fee',
  resortFee: 'Resort fee',
  weeklyDiscount: 'Weekly discount',
  monthlyDiscount: 'Monthly discount',
  priceForExtraPerson: 'Price for extra person',
  refundableDamageDeposit: 'Refundable damage deposit',
  couponDiscount: 'Coupon discount',
  checkinFee: 'Checkin fee',
  shareholderDiscount: 'Share holder discount',
  lastMinuteDiscount: 'Last minute discount',
  employeeDiscount: 'Employee discount',
  otherSpecialDiscount: 'Other special discount',
  salesTax: 'Sales tax',
  hotelTax: 'Hotel tax',
  vat: 'VAT',
  lodgingTax: 'Lodging tax',
  transientOccupancyTax: 'Transient occupancy tax',
  cityTax: 'City tax',
  roomTax: 'Room tax',
  otherTaxes: 'Other taxes',
}

export const VIEW = {
  LIST: 'LIST',
  DETAIL: 'DETAIL',
  SELECT_DATES: 'SELECT_DATES',
  SELECT_GUEST: 'SELECT_GUEST',
  SELECT_PAYMENT: 'SELECT_PAYMENT',
  BOOKING_SUCCESSED: 'BOOKING_SUCCESSED',
}

export const SUPPORTED_CURRENCIES = [
  {
    key: 'USD',
    symbol: '$',
  },
  {
    key: 'GBP',
    symbol: '£',
  },
  {
    key: 'EUR',
    symbol: '€',
  },
  {
    key: 'AUD',
    symbol: 'AU$',
  },
  {
    key: 'SGD',
    symbol: 'S$',
  },
  {
    key: 'CAD',
    symbol: 'CA$',
  },
  {
    key: 'HKD',
    symbol: 'HK$',
  },
  {
    key: 'CNY',
    symbol: '¥',
  },
  {
    key: 'NZD',
    symbol: 'NZ$',
  },
  {
    key: 'INR',
    symbol: '₹',
  },
  {
    key: 'VND',
    symbol: '₫',
  },
  {
    key: 'AED',
    symbol: 'د.إ',
  },
  {
    key: 'KRW',
    symbol: '₩',
  },
  {
    key: 'THB',
    symbol: '฿',
  },
  {
    key: 'BRL',
    symbol: 'R$',
  },
  {
    key: 'PLN',
    symbol: 'zł',
  },
  {
    key: 'JPY',
    symbol: '¥',
  },
]
export const PROVIDER_NETWORKS = [
  {
    hex: '0x1',
    decimal: '1',
    name: 'Ethereum Network',
  },
  {
    hex: '0xaa36a7',
    decimal: '11155111',
    name: 'Sepolia Testnet',
  },
  {
    hex: '0x3',
    decimal: '3',
    name: 'Ropsten Test Network',
  },
  {
    hex: '0x4',
    decimal: '4',
    name: 'Rinkeby Test Network',
  },
  {
    hex: '0x5',
    decimal: '5',
    name: 'Goerli Test Network',
  },
  {
    hex: '0x2a',
    decimal: '42',
    name: 'Kovan Test Network',
  },
  {
    hex: '0x38',
    decimal: '56',
    name: 'BSC Main Network',
  },
  {
    hex: '0x61',
    decimal: '97',
    name: 'BSC Test Network',
  },
  {
    hex: '0x89',
    decimal: '137',
    name: 'Polygon Main Network',
  },
  {
    hex: '0x13881',
    decimal: '80001',
    name: 'Mumbai Test Network',
  },
  {
    hex: '0x13882',
    decimal: '80002',
    name: 'Polygon Amoy Testnet',
  },
]
